import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useI18n } from './i18n/i18n-provider';
import {
  pickAdminLandingForRoles,
  pickDefaultLandingForRoles,
  useSession,
} from './session/session-provider';
import { buildSignInPath } from './session/auth-routing';
import { AuthenticatedLayout } from './layouts/authenticated-layout';

export function RequireAuthenticatedLayout() {
  const { t } = useI18n();
  const session = useSession();
  const location = useLocation();

  if (session.status === 'loading') {
    return (
      <div className="page">
        <h1 className="page__headline">{t('auth.loadingTitle')}</h1>
        <p className="page__lead">{t('common.loading')}</p>
      </div>
    );
  }

  if (!session.isAuthenticated || !session.user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={buildSignInPath(returnTo)} replace />;
  }

  if (session.managedMembership && !session.tenant && location.pathname !== '/account' && location.pathname !== '/help') {
    return <Navigate to="/account" replace />;
  }

  return <AuthenticatedLayout />;
}

export function RequireAttendeeWorkspace() {
  const session = useSession();

  if (!session.user) return <Navigate to="/signin" replace />;
  if (!session.canAccessAttendeeWorkspace) {
    return <Navigate to={pickDefaultLandingForRoles(session.user.roles)} replace />;
  }
  return <Outlet />;
}

export function RequireAdminWorkspace() {
  const session = useSession();

  if (!session.user) return <Navigate to="/signin" replace />;
  if (!session.canAccessAdminWorkspace) {
    return <Navigate to={pickDefaultLandingForRoles(session.user.roles)} replace />;
  }
  return <Outlet />;
}

export function RequirePlatformWorkspace() {
  const session = useSession();

  if (!session.user) return <Navigate to="/signin" replace />;
  if (!session.isPlatformAdmin) {
    return <Navigate to={pickDefaultLandingForRoles(session.user.roles)} replace />;
  }
  return <Outlet />;
}

export function RequirePrivacyRead() {
  const session = useSession(); const { t } = useI18n();
  if (!session.hasPermission('privacy:read')) return <section className="page"><h1>{t('privacy.title')}</h1><p role="alert">{t('auth.forbidden')}</p></section>;
  return <Outlet />;
}
export function RequireBrandingManage() {
  const session = useSession(); const { t } = useI18n();
  if (!session.hasPermission('branding:manage')) return <section className="page"><h1>{t('branding.title')}</h1><p role="alert">{t('auth.forbidden')}</p></section>;
  return <Outlet />;
}

export function AdminIndexRedirect() {
  const session = useSession();
  if (!session.user) return <Navigate to="/signin" replace />;
  return <Navigate to={pickAdminLandingForRoles(session.user.roles)} replace />;
}
